export const CORPCUST = "CORPCUST";
export const CORPCUST_NUMBER = "1";